import { chunk as _chunk, find as _find, isObject as _isObject } from 'lodash';

const reward = 30;

const actions = {
  startRound: ({ commit, rootGetters }) => {
    commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
      root: true
    });
    commit('SET_CURRENT_QUESTION', 0, { root: true });
    commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
  },
  startQuestion: ({ commit, dispatch, rootGetters }) => {
    return dispatch('startClockForActivePlayer', null, { root: true }).then(
      () => {
        commit('END_PLAYER_FIRST_TURN', rootGetters.activePlayer.id, {
          root: true
        });
        commit('SHOW_ROUND_PLAYSCREEN', null, { root: true });
      }
    );
  },
  answerQuestion: ({ commit, getters, dispatch, rootGetters }, keywordId) => {
    const playerId = rootGetters.activePlayer.id;
    commit('REWARD_PLAYER', { playerId, score: reward }, { root: true });
    commit('MARK_KEYWORD_AS_FOUND', { keywordId, playerId }, { root: true });
    if (getters.allKeywordsAreFound) {
      dispatch('stopClock');
    }
  },
  nextQuestion: ({ dispatch, commit, rootGetters }) => {
    if (rootGetters.nextPlayerToStartAQuestion) {
      commit('DISABLE_REVIEW_MODE', null, { root: true });
      commit('RESET_ALL_PLAYERS_TURNS', null, { root: true });
      commit('RESET_FOUND_KEYWORDS', null, { root: true });
      commit('NEXT_QUESTION', null, { root: true });
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerToStartAQuestion.id, {
        root: true
      });
      commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
    } else {
      dispatch('nextRound', null, { root: true });
    }
  },
  stopClock: ({ dispatch, commit, getters, rootGetters }, time) => {
    commit('STOP_CLOCK', time, { root: true });
    dispatch('endActivePlayerTurn', null, { root: true });
    if (!getters.allKeywordsAreFound && rootGetters.nextPlayerByLowestScore) {
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
        root: true
      });
    } else {
      dispatch('enableReviewMode', null, { root: true });
    }
  }
};

const getters = {
  questions(state, getters, rootState) {
    return rootState.questionsPerRound[2].questions;
  },
  activeQuestion(state, getters, rootState) {
    return getters.questions[rootState.game.currentQuestion];
  },
  activeHintsPerRow(state, getters) {
    return _chunk(getters.activeQuestion.hints, 3);
  },
  activeKeywords(state, getters, rootState, rootGetters) {
    const colors = ['yellow', 'teal', 'green'];
    const keywords = getters.activeQuestion.keywords;
    return keywords.map((keyword, keywordId) => {
      const foundKeyword = _find(
        rootState.game.foundKeywords,
        k => k.keywordId === keywordId
      );
      return {
        id: keywordId,
        name: keyword,
        found: _isObject(foundKeyword),
        foundBy: foundKeyword
          ? rootGetters.players[foundKeyword.playerId].name
          : false,
        color: colors[keywordId],
        score: reward
      };
    });
  },
  allKeywordsAreFound(state, getters, rootState) {
    return (
      rootState.game.foundKeywords.length ===
      getters.activeQuestion.keywords.length
    );
  }
};

export default {
  namespaced: true,
  actions,
  getters
};
